import angular from "angular";

angular
    .module('app')
    .component('reviewReplyForm', {
        template: require('./review-reply-form.html'),
        controller: ['$http', 'Notifier', 'trans', 'Auth', 'moment', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, Notifier, trans, Auth, moment) {

    let $ctrl = this;
    $ctrl.reply = null;

    $ctrl.$onInit = function () {
        $ctrl.review = $ctrl.resolve.review;
        $ctrl.rating = $ctrl.resolve.review.rating;
        $ctrl.reply = $ctrl.resolve.review.reply ? $ctrl.resolve.review.reply : null;
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let params = {
            reply: $ctrl.reply
        };

        $http
            .post(`/admin/reviews/${$ctrl.resolve.review.id}/reply`, params)
            .then(
                function (response) {
                    $ctrl.loading = false;
                    Notifier.success('Ответ успешно отправлен', 3);
                    $ctrl.close({$value: {reply: $ctrl.reply}});
                },
                function (error) {
                    Notifier.error(error.data.message, 3);
                    $ctrl.loading = false;
                }
            );
    };

}
